const localizers = {
  'loading.msg': () => `Φόρτωση...`,
  'logon.message.msg': () => `Απαιτείται πιστοποίηση. Εισαγάγετε ένα έγκυρο αναγνωριστικό χρήστη και κωδικό πρόσβασης.`,
  'logon.button.msg': () => `Σύνδεση...`,
  'SASServer.logonError.msg': () => `Δεν είναι δυνατή η σύνδεση στον διακομιστή.`,
  'SASServer.genericError.msg': () => `Δεν είναι δυνατή η πρόσβαση στον διακομιστή.`,
}
export default localizers;
